
import Button from "@/components/base/Button"
import Card from "@/components/base/card/Card"
import themes from "@/mixins/themes"
import jobFeatures from "@/mixins/jobFeatures"

import { OABALYTICS_APPRENTICESHIP_APPLY_BTN } from "@/enums/oabalytics"

export default {
    name: "JobApprenticeshipDatePicker",
    components: { Button, Card },
    mixins: [jobFeatures, themes],
    emits: ["interested"],
    props: {
        job: {
            type: Object,
            required: true,
        },
        forNextYears: {
            type: Number,
            default: 2,
        },
        hideHeadline: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        externalApplicationUrl() {
            if (!this.featureExternalApplication) return
            const url =
                this.job.external_application_url ?? this.job.external_website
            if (!url) return ""
            return url
        },
        prefix() {
            return new Intl.DateTimeFormat("de-DE", {
                day: "2-digit",
                month: "long",
            }).format(this.dateOfStart)
        },
        dateOfStart() {
            if (!this.job.date_of_start) {
                return new Date(new Date().getFullYear(), 8, 1)
            }
            return new Date(this.job.date_of_start)
        },
        currentYear() {
            if (this.job.date_application_deadline) {
                const application_deadline = new Date(
                    this.job.date_application_deadline
                )
                if (application_deadline < new Date()) {
                    return application_deadline.getFullYear() + 1
                }
            }
            return this.dateOfStart.getFullYear()
        },
        buttonYears() {
            return [...Array(this.forNextYears + 1).keys()]
        },
    },
    methods: {
        onApply(year) {
            if (!this.$can.sendInterest()) return
            this.$oabalytics.trackEvent(
                OABALYTICS_APPRENTICESHIP_APPLY_BTN,
                year || "custom"
            )
            if (!year) {
                this.$emit("interested", { year: "unknown" })
            } else {
                const string = `${this.prefix} ${year}`
                this.$emit("interested", { year: string })
            }
        },
    },
}
